import classnames from 'classnames';
import { DSSpinner } from 'designSystem/animations';
import React, { CSSProperties, MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';
import './styles.scss';

interface ButtonProps {
	btnType?:
		| 'primary'
		| 'secondary'
		| 'outline'
		| 'outline-white'
		| 'default'
		| 'default-rounded'
		| 'transparent'
		| 'card-button-white'
		| 'card-button-grey'
		| 'primary100'
		| 'primary400'
		| 'border'
		| 'borderless'
		| 'middle-border'
		| 'small-border'
		| 'plus'
		| 'tab-button'
		| 'ghost'
		| 'teritary'
		| 'dialog-warning-accept'
		| 'dialog-warning-cancel'
		| 'dialog-success-accept'
		| 'dialog-success-cancel'
		| 'dialog-error-accept'
		| 'dialog-error-cancel'
		| 'dialog-info-accept'
		| 'dialog-info-cancel'
		| 'pagination';
	btnHeight?: 'small' | 'medium' | 'large';
	loading?: boolean;
	disabled?: boolean;
	type?: 'submit' | 'button' | 'reset';
	className?: string;
	onClick?: MouseEventHandler<any>;
	abbr?: string;
	title?: string;
	style?: CSSProperties;
	lowercase?: boolean;
	link?: string;
	id?: string;
	href?: string;
	cyTestRef?: string;
}
export const Button: React.FC<ButtonProps> = (props) => {
	const onClick: MouseEventHandler<any> = (e) => !props.loading && props.onClick && props.onClick(e);
	let button = (
		<button
			title={props.abbr || ''}
			type={props.type || 'submit'}
			className={classnames(
				'btn',
				'btn-common',
				`btnHeight--${props.btnHeight || 'medium'}`,
				`btn-${props.btnType || 'default'}`,
				{ 'text--lowercase': props.lowercase },
				props.className,
			)}
			data-cy={props.cyTestRef}
			id={props.id}
			disabled={props.loading || props.disabled}
			style={props.style || {}}
			onClick={!props.disabled && !props.loading ? onClick : () => {}}
		>
			{props.loading ? (
				<span>
					<DSSpinner className="size-4" />
				</span>
			) : typeof props.children === 'string' ? (
				props.children
			) : (
				props.children
			)}
		</button>
	);
	if (props.link) {
		button = <Link to={props.link}>{button}</Link>;
	}
	if (props.href) {
		button = (
			<a href={props.href} target="_blank" rel="noopener noreferrer">
				{button}
			</a>
		);
	}
	if (props.abbr) {
		return (
			<abbr title={props.abbr || ''} className="custom-abbr">
				{button}
			</abbr>
		);
	}
	return button;
};

export default Button;
